import React from "react";
import { render } from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AuthErrorPage from "../components/AuthErrorPage";
import UIProvider from "../providers/UIProvider";
import { disableReactDevTools } from "./disableDevTools";
import initDatadogLogging from "./initDatadogLogging";
import isChunkLoadError from "./isChunkLoadError";
function handleChunkLoadError(error) {
    const chunkLoadError = isChunkLoadError(error);
    if (chunkLoadError) {
        window.location.reload();
    }
}
export function bootstrapApp({ App, ErrorScreen, Auth0Provider, Auth0ProviderOptions, querySelector, DEBUG, messages, datadogLoggingOptions, defaultLocale, }) {
    disableReactDevTools(!DEBUG);
    if (datadogLoggingOptions === null || datadogLoggingOptions === void 0 ? void 0 : datadogLoggingOptions.enabled) {
        initDatadogLogging(datadogLoggingOptions);
    }
    if (Auth0Provider && Auth0ProviderOptions) {
        render(React.createElement(React.StrictMode, null,
            React.createElement(UIProvider, { messages: messages, debug: DEBUG },
                React.createElement(BrowserRouter, null,
                    React.createElement(Auth0Provider, { prompt: "select_account", ...Auth0ProviderOptions },
                        React.createElement(Switch, null,
                            React.createElement(Route, { path: "/auth-error", exact: true, component: AuthErrorPage }),
                            React.createElement(Route, { path: "*" },
                                React.createElement(ErrorBoundary, { FallbackComponent: ErrorScreen, onError: handleChunkLoadError },
                                    React.createElement(App, null)))))))), document.querySelector(querySelector));
    }
    else {
        render(React.createElement(React.StrictMode, null,
            React.createElement(UIProvider, { messages: messages, debug: DEBUG, defaultLocale: defaultLocale },
                React.createElement(BrowserRouter, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { path: "/auth-error", exact: true, component: AuthErrorPage }),
                        React.createElement(Route, { path: "*" },
                            React.createElement(ErrorBoundary, { FallbackComponent: ErrorScreen, onError: handleChunkLoadError },
                                React.createElement(App, null))))))), document.querySelector(querySelector));
    }
}
//# sourceMappingURL=bootstrapApp.js.map